<template>
  <div class="audit-page">
    <div class="header">
      <header-back @back="onClickBack">
        <template #center>
          <choose-type
            v-if="typeOptions.length"
            :value="type"
            :options="typeOptions"
            @change="handleChangeType"
          />
        </template>
        <template #right>
          <div
            class="filter-set fs-blue"
            @click="openFilter"
          >
            <i class="iconfont iconicon-test29 fs-gray" />{{ $t('message["91"]') }}
          </div>
        </template>
      </header-back>
    </div>
    <my-list
      ref="myList"
      :from="from"
      :type-param="_type"
      :keywords="keywords"
      :keywords-str="keywordsStr"
    />
    <filter-form
      :visible.sync="showFilterModal"
      :from="from"
      :type-param="_type"
      :keywords="keywords"
      class="filter-modal"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import eventBus from '@/lib/eventBus'
import HeaderBack from '@/components/mobile/HeaderBack.vue'
import ChooseType from '@/components/mobile/ChooseType'
import FilterForm from './Filter'
import MyList from './List'

export default {
  components: {
    HeaderBack,
    ChooseType,
    FilterForm,
    MyList
  },
  data () {
    return {
      showFilterModal: false
    }
  },
  computed: {
    ...mapState(['menuDatas']),
    permissionMenuList () {
      const { permissionMenuList = [] } = this.menuDatas || {}
      return permissionMenuList
    },
    query () {
      return this.$route.query || {}
    },
    from () {
      return this.query.from || 'audit'
    },
    type () {
      return this.query.type
    },
    _type () {
      let _type = this.type === 'wait-audit' ? 0 : this.type === 'refused-audit' ? -1 : ''
      return _type
    },
    typeOptions () {
      let options = []
      const { child = {} } = this.permissionMenuList['inquiry-audit'] || {}
      for (let k in child) {
        let obj = {}
        obj.key = k
        obj.name = child[k].name
        options.push(obj)
      }
      return options
    },
    keywordsStr () {
      return this.$route.query.keywords
    },
    keywords () {
      let keywords = {}
      if (this.keywordsStr) {
        keywords = JSON.parse(decodeURIComponent(this.keywordsStr))
      }
      return keywords
    }
  },
  created () {
    this.permissionMenu()
    eventBus.$on('showFilter', this.openFilter)
  },
  methods: {
    ...mapActions(['permissionMenu']),
    onClickBack () {
      this.$router.push({
        name: 'ProjectIndex'
      })
    },
    handleChangeType (type) {
      this.$router.push({
        name: 'InqueryAudit',
        query: {
          from: this.from,
          type
        }
      })
    },
    openFilter () {
      this.showFilterModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-set {
  padding-right: 5px;
  .iconfont {
    margin-right: 4px;
  }
}
</style>
